import Cookies from 'js-cookie'
import { CACHE_KEY } from './constant'

export const userChecker = (function() {
  // 私有变量
  let stateUserId = null

  return {
    setStateUserId(userId) {
      if (userId === null) {
        stateUserId = null
      } else {
        stateUserId = String(userId)
      }
    },
    checkCookieUser() {
      // 此处存在优化点：如果当前页面是活动状态，就不需要每次都从Cookie中读userId,而是读一次，写入内存
      // 当后台存在轮询这种情况，才有必要每个接口都从cookie中拿userId进行判断
      const cookieUserId = Cookies.get(CACHE_KEY.COOKIE_USER_ID) || null
      if (stateUserId !== null) {
        return cookieUserId && cookieUserId !== stateUserId
      }
      return cookieUserId === null
    }
  }
}())
